import { render } from "./general-config.vue?vue&type=template&id=1f3a8bd4&ts=true"
import script from "./general-config.vue?vue&type=script&lang=ts"
export * from "./general-config.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__